export const ALL_CLASSIFICATION_OPTION = 'all';
export const EXTRA_BOARD_CLASSIFICATION_OPTION = 'extraboard';
export const REGULAR_CLASSIFICATION_OPTION = 'regular';
export const ALL_CLASSIFICATION_LABEL = 'All';
export const EXTRA_BOARD_CLASSIFICATION_LABEL = 'Extraboard';
export const REGULAR_CLASSIFICATION_LABEL = 'Regular';
